// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorBoundary_container__VOLfG"};